<a
  (click)="selectAll()"
  class="btn btn-default btn-xs"
  [class.disabled]="disabled$ | async"
  [matTooltip]="tooltip"
>
  <fa-icon [icon]="faCheckDouble" [fixedWidth]="true"></fa-icon>
</a>
